import { get } from "lodash";

export const toApiDocumentTemplate = (row = {}) => {
  if (!row.templateId) return null;
  return {
    templateId: row.templateId,
    ...(row.templateName ? { templateName: row.templateName } : {}),
    ...(row.type ? { type: row.type } : {}),
    ...(row.area ? { area: row.area } : {}),
    ...(row.outputName ? { outputName: row.outputName } : {}),
    ...(get(row, "conditions.rules.length", 0) > 0
      ? { conditions: row.conditions }
      : {}),
  };
};
